import * as i from 'types';

export const contentSelector = (
  input: ContentSelectorInput,
): ContentSelectorResponse[] => {
  const data = input.edges.map((edge) => edge.node);
  return data;
};

type ContentSelectorInput =
  | GatsbyTypes.ContentfulQuestionsConnection
  | GatsbyTypes.ContentfulQuestionnaireBusConnection
  | GatsbyTypes.ContentfulCarsConnection
  | GatsbyTypes.ContentfulChargingStationsConnection
  | GatsbyTypes.ContentfulVariablesConnection
  | GatsbyTypes.ContentfulBlogConnection
  | GatsbyTypes.ContentfulFaqConnection
  | GatsbyTypes.ContentfulOutcomesConnection
  | GatsbyTypes.ContentfulComponentHeaderBlockConnection
  | GatsbyTypes.ContentfulContentPartnersConnection;

type ContentSelectorResponse =
  | GatsbyTypes.ContentfulQuestions
  | GatsbyTypes.ContentfulQuestionnaireBus
  | GatsbyTypes.ContentfulChargingStations
  | GatsbyTypes.ContentfulCars
  | GatsbyTypes.ContentfulVariables
  | GatsbyTypes.ContentfulBlog
  | GatsbyTypes.ContentfulFaq
  | GatsbyTypes.ContentfulOutcomes
  | i.ChargingStation
  | i.Service
  | i.Car
  | i.Question
  | i.Partner
  | GatsbyTypes.ContentfulContentPartners
  | GatsbyTypes.ContentfulComponentHeaderBlock;

export const carSelector = (
  cars: GatsbyTypes.ContentfulCars[],
  size: keyof i.FleetInput,
  type: 'ev' | 'petrol' = 'ev',
  isInTcoTool?: boolean,
) => {
  let filteredCars = cars.filter((car) => car.type === type);

  if (isInTcoTool) {
    filteredCars = filteredCars.filter((car) => car.shouldBeInTcoTool === true);
  }

  return filteredCars.find((car) => car.comparison === size);
};
